(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MovableCoord", [], factory);
	else if(typeof exports === 'object')
		exports["MovableCoord"] = factory();
	else
		root["eg"] = root["eg"] || {}, root["eg"]["MovableCoord"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition